import { Draft } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

export const clearCouponCode = (state: Draft<IPaymentState>) => {
  state.couponCode = null;
  state.updatedAt = Date.now();
};
